import { Component, ViewChild, EventEmitter } from '@angular/core';
import { Global } from "../../classes/global";
import { UserService } from "../../services/user/user.service";
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NeedAuthorize } from "../../classes/needAuthorize";
import { MockupService } from "../../services/mockup/mockup.service";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';

import * as _ from 'lodash';
import { LogTimeService } from "../../services/log-time/log-time.service";
import { MerchantService } from "../../services/merchant/merchant.service";
import { TrademarkService } from "../../services/trademark/trademark.service";
import { UploadDesignService } from "../../services/upload-design.service";
import { DesignFile } from "../upload-design/upload-design.component";

@Component({
  selector: 'app-mockup-list',
  templateUrl: './mockup-list.component.html',
  styleUrls: ['./mockup-list.component.scss']
})
export class MockupListComponent extends NeedAuthorize {
  constructor(protected router: Router,
    protected userService: UserService,
    protected titleService: Title,
    public global: Global,
    private activeRoute: ActivatedRoute,
    private mockupService: MockupService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private logTimeService: LogTimeService,
    private merchantService: MerchantService,
    private trademarkService: TrademarkService,
    private uploadDesignService: UploadDesignService
  ) {
    super(router, userService, titleService);

    this.activeRoute.queryParams.subscribe(params => {
    });

    // Removed getAvailableDesigners() - now loaded separately when opening modal
    this.queryMockups(1);
    this.getMerchants();
    this.getMerchantGroups();
  }

  ngOnInit(): void {
  }

  @ViewChild('mockupModal', { static: false })
  private mockupModal: NgbModalRef;

  @ViewChild('addToAccountModal', { static: false })
  private addToAccountModal: NgbModalRef;

  getImages: EventEmitter<any> = new EventEmitter<any>();
  openConfirmDeleteMockupAction: EventEmitter<any> = new EventEmitter<any>();

  query = {
    designerId: undefined,
    queryString: '',
    quickFilter: undefined,
    createdDate: undefined,
    merchantGroupId: undefined,
    postedMerchantId: undefined,
    pageNumber: 1,
    pageSize: 30
  }

  queryResult={
    items: [],
    backlogCount: 0,
    waitingForDesCount: 0,
    waitingApprovalCount: 0,
    total: 0
  };

  trademarkMatches: { [key: string]: any[] } = {}; // Store trademark matches by mockup id

  designers = [];
  merchants = [];
  merchantGroups = [];

  selectedMerchant: any = undefined;

  mockupDetail = {
    id: '',
    sku: '',
    merchantGroupId: '',
    name: '',
    description: '',
    thumbnails: '',
    note: '',
    designerId: '',
    destinationProductLink: '',
    destinationProductThumbnail: '',
    progressState: 0,
    availableDesigners: [],
    availableMerchantGroups: [],
    desPoint: 0,
  }
  logs = [];
  categories = [];
  uploadProgress: number | null = null;
  temptPreviewImages= [];
  timerRunning = false;

  queue: any[] = [];

  merchantTemplates: any[] = [];
  selectedTemplate: any;
  accountOptions = {
    overrideDescription: false,
    useAIName: false,
    useAIDescription: false
  };

  trademarkCheckResult: any = null;
  checkingTrademark = false;

  toggleQuickFilter(type) {
    if (type === this.query.quickFilter) {
      this.query.quickFilter = null;
    } else {
      this.query.quickFilter = type;
    }

    this.queryMockups(1);
  };

  queryMockups(page = undefined) {
    if (page != undefined) {
      this.query.pageNumber = page;
    }

    this.global.pageLoading = true;
    this.mockupService.query(this.query)
      .subscribe(data => {
        this.global.pageLoading = false;
        this.queryResult = data;
        // Load badge counts separately for better performance
        this.loadBadgeCounts();
        // Check trademarks for each mockup name
        this.checkTrademarksForMockups();
      });
  };

  loadBadgeCounts() {
    this.mockupService.getBadgeCounts(this.query)
      .subscribe(data => {
        this.queryResult.backlogCount = data.backlogCount;
        this.queryResult.waitingForDesCount = data.waitingForDesCount;
        this.queryResult.waitingApprovalCount = data.waitingApprovalCount;
        this.queryResult.total = data.total;
      });
  };

  // Removed getAvailableDesigners() - now loaded separately when opening modal

  openCreateMockupModal(mockup) {
    this.resetMockupDetail();
    this.global.pageLoading = true;

    var mockupId = 'newID';
    if (mockup) {
      mockupId = mockup.id;
    }

    this.mockupService.getMockupEdit(mockupId).subscribe(data => {
      this.mockupDetail = data;

      this.modalService.open(this.mockupModal, { windowClass: 'xlModal' });

      // Ensure merchantGroupId is set for new mockups
      if (!this.mockupDetail.merchantGroupId && this.mockupDetail.availableMerchantGroups && this.mockupDetail.availableMerchantGroups.length > 0) {
        this.mockupDetail.merchantGroupId = this.mockupDetail.availableMerchantGroups[0].id;
      }

      if (this.mockupDetail.destinationProductThumbnail
        && this.mockupDetail.destinationProductThumbnail.indexOf('tạo link cho file') == -1) {
        var images = this.mockupDetail.destinationProductThumbnail.split('\n');
        this.temptPreviewImages = images;
      }

      // Always load designers - loadDesignersForCurrentState will handle merchantGroupId logic
      // Call it after ensuring merchantGroupId is set
      this.loadDesignersForCurrentState();

      this.global.pageLoading = false;
    });

    this.mockupService.getLogs(mockup)
      .subscribe(data => {
        this.logs = data;
      });
  };

  passToDesigner() {
    if (!this.mockupDetail.designerId) {
      return;
    }
    this.mockupDetail.progressState = 1;
    this.saveMockup();
  }

  passToBacklog() {
    this.mockupDetail.progressState = 0;
    this.saveMockup();
  }

  passToApproval() {
    if (!this.mockupDetail.destinationProductLink) {
      this.toastr.error('Thiếu link sản phẩm');
      return;
    }

    if (this.timerRunning) {
      this.toastr.error('Bộ đếm thời gian vẫn đang chạy');
      return;
    }

    this.mockupDetail.progressState = 2;
    this.saveMockup();
  }

  passToDone() {
    this.mockupDetail.progressState = 3;
    this.saveMockup();
  }

  saveMockup() {
    if (!this.mockupDetail.sku || !this.mockupDetail.merchantGroupId || !this.mockupDetail.name) {
      this.toastr.error('Mockup thiếu thông tin');
      return;
    }

    this.global.pageLoading = true;
    this.mockupService.saveMockup(this.mockupDetail).subscribe(data => {

      this.global.pageLoading = false;
      this.modalService.dismissAll();
      this.toastr.success('Mockup được lưu');

      this.queryMockups();
    });

  };

  updateSingleValue(mockup, type, value) {
    if (type == "Sku") {
      mockup.sku = value;
    } else if (type == "Name") {
      mockup.name = value;
    } else if (type == "Description") {
      mockup.description = value;
    } else if (type == "Note") {
      mockup.note = value;
    } else if (type == "Designer") {
      mockup.desingerId = value;
    } else if (type == "ProgressState") {
      mockup.progressState = value;
    } else if (type == "DesPoint") {
      mockup.desPoint = value;
    } else if (type == "Group") {
      // When merchant group changes, reload designers
      mockup.merchantGroupId = value;
      if (mockup === this.mockupDetail) {
        // If this is the modal mockup, reload designers
        this.loadDesignersForCurrentState();
      }
    }

    // Only call API if mockup has an id (not for new mockups)
    if (!mockup.id || mockup.id === 'newID' || mockup.id === '') {
      // For new mockups, just update the local value without API call
      return;
    }

    this.mockupService.updateSingleValue(mockup, type).subscribe(data => {

        for (var i = 0; i < this.queryResult.items.length; i++) {

          var model = _.find(data, o => o.id === this.queryResult.items[i].id);
          if (model == undefined || model.length === 0) {
            continue;
          }
          this.queryResult.items[i] = model;
        }

      },
      error => {
      });
  };

  resetMockupDetail() {
    this.mockupDetail = {
      id: '',
      sku: '',
      merchantGroupId: '',
      name: '',
      description: '',
      thumbnails: '',
      note: '',
      designerId: '',
      progressState: 0,
      availableDesigners: [],
      destinationProductLink: '',
      destinationProductThumbnail: '',
      availableMerchantGroups: [],
      desPoint: 0,
    }
    this.logs = [];
    this.temptPreviewImages = [];
    this.trademarkCheckResult = null;
  }

  onSubmitDesignFiles(designFiles: DesignFile[]) {
    if (!designFiles || designFiles.length === 0) {
      return;
    }

    const sortedFiles = designFiles.sort((a, b) => {
      const order = { Front: 0, Back: 1, Left: 2, Right: 3 };
      return order[a.position] - order[b.position];
    });

    this.uploadProgress = 1;
    this.global.pageLoading = true;

    this.uploadDesignService.uploadDesignFilesWithProgress(
      sortedFiles.map(df => ({ file: df.file, position: df.position })),
      (progress) => {
        this.uploadProgress = progress;
      }
    ).then((result) => {
      this.uploadProgress = null;
      this.global.pageLoading = false;
      this.mockupDetail.destinationProductLink = result.destinationProductLinkText;
      this.mockupDetail.destinationProductThumbnail = result.previewImages.join('\n');
      this.temptPreviewImages = result.previewImages.filter(link => !!link);
      this.persistDestinationLinkAfterUpload();
      this.toastr.success('Design files uploaded successfully!');
    }).catch((error) => {
      this.uploadProgress = null;
      this.global.pageLoading = false;
      console.error('Upload error:', error);
      this.toastr.error('Failed to upload design files: ' + (error?.message || error));
    });
  }

  private persistDestinationLinkAfterUpload() {
    const mockup = this.mockupDetail;
    if (!mockup?.id || mockup.id === 'newID' || mockup.id === '') {
      return;
    }
    if (!mockup.destinationProductLink) {
      return;
    }

    this.mockupService.updateSingleValue(mockup, 'DestinationProductLink').subscribe(
      () => { },
      () => {
        this.toastr.warning('Đã upload file nhưng chưa lưu link lên server — hãy lưu mockup thủ công.');
      }
    );
  }

  recalculateDesPoint(event) {
    this.logTimeService.calculateDesPoint(this.mockupDetail.id, 'Design')
      .subscribe(data => {
        this.mockupDetail.desPoint = data;
        this.updateSingleValue(this.mockupDetail, 'DesPoint', data);
      });
  }

  shortLinkForText(text, threshold = 40): string {
    var result = this.shortLinkForTextWithSplitChar(text, threshold, ' ');
    result = this.shortLinkForTextWithSplitChar(result, threshold, '\n');
    return result;
  }

  shortLinkForTextWithSplitChar(text, threshold, splitchar) {
    if (!text) {
      return '';
    }
    const words = text.split(splitchar);
    for (let i = 0; i < words.length; i++) {
      const word = words[i];
      if (word.startsWith("http") && word.length > threshold) {
        words[i] = word.slice(0, threshold) + "...";
      }
    }

    var result = words.join(splitchar);
    return result;
  }

  assignTimerRunning(event) {
    this.timerRunning = (event == "true");
  }

  deletedMockup;
  confirmDeleteMockup(deletedMockup) {
    this.openConfirmDeleteMockupAction.emit(deletedMockup);
    this.deletedMockup = deletedMockup;
  }

  deleteMockup() {
    this.global.pageLoading = true;

    this.deletedMockup.isDeleted = 1;
    this.mockupService.saveMockup(this.deletedMockup).subscribe(data => {

      this.global.pageLoading = false;
      this.toastr.success('Mockup được xóa');
      this.modalService.dismissAll();
      this.queryMockups();
    });

  }

  pushProductToAccount(mockups) {

  }

  getMerchants() {
    this.merchantService.getTeamQuynhMerchants().subscribe(data => {
      this.merchants = data;
    });
  }

  getMerchantGroups() {
    this.merchantService.getTeamQuynhMerchantGroups().subscribe(data => {
      this.merchantGroups = data;
    });
  }

  addToQueue(mockup: any) {
    const index = this.queue.findIndex(item => item.id === mockup.id);

    if (index === -1) {
      this.queue.push(mockup);
    } else {
      this.queue.splice(index, 1);
    }
  }

  removeFromQueue(mockup: any) {
    this.queue = this.queue.filter(item => item.id !== mockup.id);
  }

  isInQueue(mockup: any): boolean {
    return this.queue.some(item => item.id === mockup.id);
  }

  openAddToAccountModal() {
    if (this.queue.length === 0) {
      this.toastr.warning('Please add items to queue first');
      return;
    }
    this.modalService.open(this.addToAccountModal, { size: 'lg' });
  }

  onMerchantChange(event) {
    // Update the selectedMerchant with the event value
    this.selectedMerchant = event;

    if (this.selectedMerchant) {
      // Load templates for selected merchant
      this.global.pageLoading = true;
      this.merchantService.getTemplates(this.selectedMerchant.merchantId).subscribe(
        templates => {
          this.merchantTemplates = templates;

          // Auto-select active template or first template
          if (templates && templates.length > 0) {
            const activeTemplate = templates.find(t => t.isActive).id;
            this.selectedTemplate = activeTemplate.id || templates[0].id;
          } else {
            this.selectedTemplate = null;
          }

          this.global.pageLoading = false;
        },
        error => {
          this.global.pageLoading = false;
          this.toastr.error('Failed to load templates');
          this.merchantTemplates = [];
          this.selectedTemplate = null;
        }
      );
    } else {
      this.merchantTemplates = [];
      this.selectedTemplate = null;
    }
  }

  processQueue() {
    if (!this.selectedMerchant || !this.selectedTemplate || this.queue.length === 0) {
      return;
    }

    const processData = {
      merchantId: this.selectedMerchant.merchantId,
      templateId: this.selectedTemplate,
      options: this.accountOptions,
      idealIds: this.queue.map(item => item.id)
    };

    this.global.pageLoading = true;

    // Check if merchant is Ebay (merchantType === 3)
    if (this.selectedMerchant.merchantType === 3) {
      // For Ebay merchants, handle file download
      this.merchantService.addProductToAccountFromIdealWithFileDownload(processData)
        .subscribe(
          (response: HttpResponse<Blob>) => {
            this.global.pageLoading = false;

            // Create a download link for the file
            const blob = new Blob([response.body], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers.get('content-disposition');
            let filename = 'Ebay_Products.xlsx';
            if (contentDisposition) {
              const filenameMatch = contentDisposition.match(/filename="(.+)"/);
              if (filenameMatch) {
                filename = filenameMatch[1];
              }
            }

            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(url);

            this.toastr.success('File downloaded successfully');
            this.queue = [];
            this.modalService.dismissAll();
          },
          error => {
            this.global.pageLoading = false;
            this.toastr.error('Failed to download file: ' + (error.error?.message || 'Unknown error'));
          }
        );
    } else {
      // For non-Ebay merchants, use the original JSON response handling
      this.merchantService.addProductToAccountFromIdeal(processData)
        .subscribe(
          response => {
            this.global.pageLoading = false;
            this.toastr.success('Items processed successfully');
            this.queue = [];
            this.modalService.dismissAll();
          },
          error => {
            this.global.pageLoading = false;
            this.toastr.error('Failed to process items: ' + (error.error?.message || 'Unknown error'));
          }
        );
    }
  }

  checkTrademark() {
    if (!this.mockupDetail.name || !this.mockupDetail.name.trim()) {
      this.toastr.warning('Please enter a product name first');
      return;
    }

    this.checkingTrademark = true;
    this.trademarkCheckResult = null;

    this.trademarkService.checkTrademark(this.mockupDetail.name).subscribe(
      data => {
        this.trademarkCheckResult = data;
        this.checkingTrademark = false;
      },
      error => {
        this.checkingTrademark = false;
        this.toastr.error('Error checking trademark: ' + (error.error?.message || 'Unknown error'));
      }
    );
  }

  loadDesignersForCurrentState() {
    // Always load designers for current user regardless of progress state
    this.loadAvailableDesignersForCurrentUser();
  }

  loadAvailableDesignersForCurrentUser() {
    this.mockupService.getAvailableDesigners().subscribe(
      designers => {
        this.mockupDetail.availableDesigners = designers || [];

        // Auto-select first designer if none selected
        if (!this.mockupDetail.designerId && this.mockupDetail.availableDesigners.length > 0) {
          this.mockupDetail.designerId = this.mockupDetail.availableDesigners[0].id;
        }
      },
      error => {
        console.error('Error loading available designers:', error);
        this.toastr.error('Error loading available designers: ' + (error.error?.message || 'Unknown error'));
        this.mockupDetail.availableDesigners = [];
      }
    );
  }

  checkTrademarksForMockups() {
    // Clear previous matches
    this.trademarkMatches = {};

    // Check trademarks for each mockup name
    this.queryResult.items.forEach(mockup => {
      if (mockup.name && mockup.name.trim()) {
        this.trademarkService.checkTrademarksInName(mockup.name).subscribe(
          matches => {
            if (matches && matches.length > 0) {
              this.trademarkMatches[mockup.id] = matches;
            }
          },
          error => {
            // Silently fail - don't show error for each check
            console.warn('Error checking trademarks for mockup:', mockup.id, error);
          }
        );
      }
    });
  }

  highlightTrademarksInName(name: string, mockupId: string): string {
    if (!name || !this.trademarkMatches[mockupId] || this.trademarkMatches[mockupId].length === 0) {
      return name;
    }

    let highlightedName = name;
    const nameLower = name.toLowerCase();

    // Sort trademarks by length (longest first) to avoid partial matches
    const sortedTrademarks = [...this.trademarkMatches[mockupId]].sort((a, b) => b.text.length - a.text.length);

    sortedTrademarks.forEach(trademark => {
      const trademarkText = trademark.text;
      const regex = new RegExp(`(${trademarkText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      highlightedName = highlightedName.replace(regex, '<mark class="trademark-highlight">$1</mark>');
    });

    return highlightedName;
  }

  getTrademarkMatches(mockupId: string): any[] {
    return this.trademarkMatches[mockupId] || [];
  }
}
